import { render, staticRenderFns } from "./StratageInfo.vue?vue&type=template&id=4efbbd58&scoped=true&"
import script from "./StratageInfo.vue?vue&type=script&lang=js&"
export * from "./StratageInfo.vue?vue&type=script&lang=js&"
import style0 from "./StratageInfo.vue?vue&type=style&index=0&id=4efbbd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efbbd58",
  null
  
)

export default component.exports